module.exports = [{"type":"title","text":"2024-11-08"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Spot: Account information push, after a new subscription, immediately push an overview of the current account, type=INIT"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-11-08.json
// module id = Np/o
// module chunks = 3